import { Box } from "@mui/material";
import NoPhotoImg from "assets/images/user.png";
import PropTypes from "prop-types";

const CompanyLogo = ({ photo, sx }) => {
  const getImageSrc = (bytes) => {
    if (!bytes) return null;

    // If the data is already a Base64 string, return it directly
    if (typeof bytes === "string" && bytes.startsWith("data:image")) {
      return bytes;
    }

    // Convert binary data to Base64 (for API responses)
    return `data:image/png;base64,${photo}`;
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      mb={1}
      sx={{
        width: "100%",
        maxWidth: 200, // Adjust max width for a clean display
        height: "auto",
        overflow: "hidden",
        borderRadius: 2, // Optional rounded corners
        boxShadow: 3, // Optional shadow for better UI
        backgroundColor: "white", // Ensure white background
        p: 1, // Padding for spacing
        ...sx,
      }}
    >
      <img
        src={getImageSrc(photo)}
        alt="Company Logo"
        style={{
          width: "100%",
          height: "auto",
          objectFit: "contain", // Ensure it scales properly
        }}
      />
    </Box>
  );
};

CompanyLogo.propTypes = {
  photo: PropTypes.any, // Allow null or undefined values
  sx: PropTypes.object,
};

export default CompanyLogo;
